var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-hours-list"},[_vm._l((_vm.handleHoursPoints),function(item){return _c('div',{key:item.label,staticClass:"calendar-hours-item"},[_c('span',{staticClass:"calendar-hours-label",class:{
          'hide': _vm.isToday && !item.visiable
        }},[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"calendar-hours-line"})])}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }